import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import queryString from 'query-string';
import {
  API_ENDPOINT,
  type ClientApiV1VoucherMyChallengesQueryString,
  useClientApiV1VoucherMyChallengesQuery,
} from '../../resources/@types/courseSchema';
import type { StringifyObject } from '../utils/typeUtil';

export function useVoucherMyChallengesQuery({
  query,
  options,
}: {
  query: StringifyObject<ClientApiV1VoucherMyChallengesQueryString>;
  options?: Parameters<typeof useClientApiV1VoucherMyChallengesQuery>[0]['options'];
}) {
  return useClientApiV1VoucherMyChallengesQuery({
    queryKey: getVoucherMyChallengesQueryKey(query),
    url: queryString.stringifyUrl(
      { url: API_ENDPOINT.CLIENT_V1_VOUCHER_MY_CHALLENGES, query },
      { skipEmptyString: true },
    ),
    options,
  });
}

export const getVoucherMyChallengesQueryKey = (
  query: StringifyObject<ClientApiV1VoucherMyChallengesQueryString>,
): QueryKeyReturnType => [API_ENDPOINT.CLIENT_V1_VOUCHER_MY_CHALLENGES, query];
